import userApi from '../api/userApi';
import {dispatchTokenRefreshed, saveStoredToken} from '../api/http';

export async function guestLogin() {
  try {
    const res = await userApi.login({ lgnUserNm: 'guest', pswd: 'guest' });
    const data = res?.data?.data;
    if (data) {
      // guest 플래그 및 누락 필드 보강
      const annotated = {
        ...data,
        guest: true,
        lgnUserNm: data.lgnUserNm || data.loginId || 'guest',
        userNm: data.userNm || 'guest'
      };
  saveStoredToken(annotated);
  dispatchTokenRefreshed(annotated);
      return annotated;
    }
  } catch (e) {
    console.warn('게스트 로그인 실패:', e.message);
  }
  return null;
}

export function isGuestUser(user) {
  if (!user) return false;
  return !!(user.guest === true || user.lgnUserNm === 'guest' || user.userNm === 'guest' || user.loginId === 'guest');
}
